<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import Badge from '@/components/ui/badge/Badge.vue'
import { Title } from '@/components/ui/title'
import { event_end_day, event_month, event_start_day, event_year } from '@/helpers/event-date'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
    workshop: Workshop
}>()
</script>

<template>
    <section class="relative z-20 mt-12 flex flex-col gap-8 md:flex-row lg:mt-24">
        <div class="flex flex-col items-start gap-2">
            <Badge variant="gradient">{{ t('Learn more') }}</Badge>
            <Title class="mt-2">{{ t('Details') }}</Title>
            <p>
                {{
                    t(
                        'The ILOS Forum is an event designed for those who want to lead the transformation of logistics in Brazil. With a program focused on innovation, strategy and results, the forum brings together the main professionals in the sector to discuss the present and future of the supply chain.',
                        { event_description: t(workshop.description) },
                    )
                }}
            </p>
        </div>

        <div class="flex h-auto w-full max-w-md flex-col gap-2 self-start rounded-[10px] bg-[#15191e] px-6 py-4">
            <p>{{ t('Date and time') }}</p>
            <time
                class="w-full max-w-[300px] text-2xl"
                v-html="
                    t('event_date', {
                        start: event_start_day(workshop.event_start_date),
                        end: event_end_day(workshop.event_end_date),
                        month: event_month(workshop.event_start_date),
                        year: event_year(workshop.event_start_date),
                    })
                "
            ></time>
        </div>
    </section>
</template>
